import { withParams } from 'vuelidate';
import { required, url, maxLength } from 'vuelidate/lib/validators';
import arrayUniq from 'array-uniq';
import { postal, phone, password } from '../validators';
import User from '../models/User';
import Coach from '../models/Coach';
import Countries from '../data/Countries';

export default {
    data: () => ({
        users: [],
    }),

    validations() {
        const validations = {
            data: {
                avatar: { },
                firstname: { required, maxlength: maxLength(255) },
                lastname: { required, maxlength: maxLength(255) },
                email: {
                    required,
                    maxlength: maxLength(255),
                    username: withParams(
                        {
                            type: 'username',
                            message: 'Diese E-Mail Adresse ist ungültig oder wird bereits verwendet.',
                        },
                        this.validUsername,
                    ),
                },
                background: { },
                region: { maxlength: maxLength(255) },
                specialization: { },
                languages: { maxlength: maxLength(255) },
                companyLogo: { },
                company: { required, maxlength: maxLength(255) },
                companyStreet: { maxlength: maxLength(255) },
                companyPostcode: { maxlength: maxLength(5), postal: postal('companyCountry') },
                companyLocation: { maxlength: maxLength(255) },
                companyCountry: { maxlength: maxLength(255) },
                companyPhone: { phone, maxlength: maxLength(255) },
                companyWebsite: { required, url, maxlength: maxLength(255) },
            },
        };

        if (!this.source) {
            validations.data.plainPassword = { required, password };
        }

        return validations;
    },

    computed: {
        languageOptions: () => Object.keys(User.LanguagesMap).map(
            lang => ({ value: lang, label: User.LanguagesMap[lang] }),
        ),
    },

    asyncComputed: {
        specializationOptions: async () => {
            const users = await Coach.get();

            return arrayUniq(users.reduce((o, u) => (u.specialization ? o.concat(u.specialization) : o), []));
        },

        countries: {
            get: () => Countries.all(),
            default: [],
        },
    },

    methods: {
        validUsername(value) {
            if (!value || (this.source && value === this.source.email)) return true;

            return this.$http.post('validation/user_email', { email: value }).then(
                () => true,
                () => false,
            );
        },
    },
};
